<template>
  <div
    id="secondary-navbar"
    class="flex items-center justify-between sticky bg-gray-900 py-2 top-0 z-50 relative"
    :class="{'hidden': isMobileApp}"
    style="height: 58px"
  >
    <div class="flex h-full items-center">
      <navigation-button
        v-if="dismissible"
        icon="sr-2 sr-v2-x"
        data-cy="dismiss-button"
        @click="onClose"
      />
      <navigation-button
        v-if="hasSideMenu"
        icon="sr-2 sr-v2-hamburger"
        @click="toggleSideMenu"
      />

      <div class="h-full flex items-center">
        <slot name="identifier" />
      </div>
    </div>

    <div class="flex px-3">
      <slot name="actions" />
    </div>

    <slot
      name="side-menu"
      :toggled="sideMenuToggled"
    />
    <slot name="overlay" />
  </div>
</template>


<script>
import NavigationButton from "./NavigationButton";
import SRCookies from "@/services/cookies";
export default {
    components: {
        NavigationButton,
    },
    props: {
        dismissible: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            sideMenuToggled: false,
        };
    },

    computed: {
        hasSideMenu() {
            return !!this.$scopedSlots["side-menu"];
        },
      isMobileApp() {
        return SRCookies.session()?.is_mobile_app === '1'
      }
    },

    methods: {
        toggleSideMenu() {
            this.sideMenuToggled = !this.sideMenuToggled;
        },
        onClose() {
            this.$emit("close");
        },
    },
};
</script>